"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.style.list': 'Stili di Scrittura',
    'route.style.create': 'Aggiungi Stile di Scrittura',
    'route.style.edit': 'Modifica Stile di Scrittura',
    'route.style.preview': 'Anteprima Stile',
};
